import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { User } from 'projects/core/src/lib/login/data/user';
import { LocalStorage } from 'ngx-webstorage';
import { UserService } from 'projects/core/src/lib/login/data/user.service';
import { KanbanBoardStore } from '../../../data/kanban-board.store';
import { MultiSelect } from 'primeng/multiselect';

@Component({
    selector: 'app-managers-filter',
    templateUrl: './managers-filter.component.html',
    styleUrls: ['./managers-filter.component.scss']
})
export class ManagersFilterComponent implements OnInit {

    @Output()
    changeDetect = new EventEmitter<any>();

    users: User[]

    @LocalStorage()
    filteredManagers: number[];

    selectedUsers: User[] = [];

    userFiltersLabel: string;

    @Output()
    filterOn = new EventEmitter<boolean>();

    @ViewChild('multiSelect', { static: true })
    multiSelect: MultiSelect

    constructor(
        protected userService: UserService,
        protected kanbanBoardStore: KanbanBoardStore
    ) {

    }

    ngOnInit(): void {

        this.userService.getProjectManagers().subscribe(users => {
            this.users = [...users]
            this.users.unshift({
                id: 0,
                name: 'No User',
                username: 'No User'
            })

            let selectedUsersIds: number[]

            if (!this.filteredManagers) {
                this.selectedUsers = this.users
                selectedUsersIds = this.users.map(user => user.id);
            }
            else {
                const uIds = this.users.map(user => user.id)
                const fUIds = this.filteredManagers;
                const colsMap = new Map(this.users.map(col => [col.id, col]));

                selectedUsersIds = uIds.filter(x => !fUIds.includes(x));
                this.selectedUsers = selectedUsersIds.map(id => colsMap.get(id));
            }

            this.filteredManagers = this.users.map(cols => cols.id).filter(colId => !selectedUsersIds.includes(colId));

            this.kanbanBoardStore.updateManagersFilter(this.filteredManagers.length > 0 ? selectedUsersIds : undefined);

            this.countFilter();
        })
    }

    updateManagers() {
        const selectedUsersIds = this.selectedUsers.map(col => col.id)

        this.filteredManagers = this.users.map(cols => cols.id).filter(colId => !selectedUsersIds.includes(colId));

        this.kanbanBoardStore.updateManagersFilter(this.filteredManagers.length > 0 ? selectedUsersIds : undefined);

        this.countFilter();
    }

    countFilter() {
        this.userFiltersLabel = this.selectedUsers.length + ' managers selected';

        if (this.selectedUsers.length === this.users.length) {
            this.userFiltersLabel = 'Filter Managers';

            this.filterOn.emit(false)
        }
        else {
            this.filterOn.emit(true)
        }
    }

    showAll() {
        this.multiSelect.toggleAll({})
    }

}
